import tracking from '../../utils/tracking';
import {
  LOGOUT,
  SESSION_SUCCESS,
  SESSION_FAIL,
  LOGIN_SUCCESS,
  USER_CONFIRMATION_SUCCESS,
  CREATE_SUCCESS as USER_CREATE_SUCCES
} from './auth';
import { CROSS_DOMAIN_NAVIGATION } from './app';
import facebookSavePrefs from '../../utils/facebook-save-prefs';
import visitor, { HAS_BOLIGAGENT } from '../../utils/visitor';

const NOOP = 'NOOP';

const SET_AUTO_ADJUST = 'user/SET_AUTO_ADJUST';
const SET_AUTO_ADJUST_SUCCESS = 'user/SET_AUTO_ADJUST_SUCCESS';
const SET_AUTO_ADJUST_FAIL = 'user/SET_AUTO_ADJUST_FAIL';

export const SESSIONPREFS = 'sessionPrefs';
export const CREATE = 'boligagents/CREATE';
export const CREATE_FAIL = 'boligagents/CREATE_FAIL';
export const CREATE_SUCCESS = 'boligagents/CREATE_SUCCESS';
export const VERIFY = 'boligagents/VERIFY';
export const VERIFY_SUCCESS = 'boligagents/VERIFY_SUCCES';
export const VERIFY_FAIL = 'boligagents/VERIFY_FAIL';
export const LOAD = 'boligagents/LOAD';
export const LOAD_SUCCESS = 'boligagents/LOAD_SUCCES';
export const LOAD_FAIL = 'boligagents/LOAD_FAIL';
export const UPDATE = 'boligagents/UPDATE';
export const UPDATE_SUCCESS = 'boligagents/UPDATE_SUCCES';
export const UPDATE_FAIL = 'boligagents/UPDATE_FAIL';
export const DELETE = 'boligagents/DELETE';
export const DELETE_SUCCESS = 'boligagents/DELETE_SUCCES';
export const DELETE_FAIL = 'boligagents/DELETE_FAIL';
export const ADJUST_SESSION = 'boligagents/ADJUST_SESSION';
const DELETE_PREF = 'boligagents/DELETE_PREF';
const DELETE_PREF_SUCCESS = 'boligagents/DELETE_PREF_SUCCESS';
export const DELETE_PREF_FAIL = 'boligagents/DELETE_PREFS_FAIL';
const ACTIVATE = 'boligagents/ACTIVATE';
const ACTIVATE_SUCCESS = 'boligagent/ACTIVATE_SUCCESS';
export const ACTIVATE_FAIL = 'boligagents/ACTIVATE_FAIL';

const ENDPOINT = '/api/boligagents';

const initialState = {
  current: null,
  sessionPrefs: [],
  loading: false
};

const MATH_VALUES = {
  rent: 'max',
  rooms: 'min',
  size: 'min'
};

const RENT_INTERVAL = 2000;
const RENT_MIN = 4000;
const RENT_MAX = 10000;

function snapRent(val) {
  if (!val || val > RENT_MAX) {
    return undefined;
  }
  if (val <= RENT_MIN) {
    return RENT_MIN;
  }
  return Math.ceil(val / RENT_INTERVAL) * RENT_INTERVAL;
}

function snapRoom(val) {
  return val < 2 ? undefined : val;
}

function getCombinedPrefs(existing, next) {
  const values = ['rent', 'rooms', 'size'];

  return values.reduce(
    (acc, item) => {
      if (next[item] !== undefined) {
        if (existing[item]) {
          acc[item] = Math[MATH_VALUES[item]](existing[item], next[item]);
        } else {
          acc[item] = next[item];
        }
      } else if (existing[item]) {
        acc[item] = existing[item];
      }
      return acc;
    },
    { area: next.area }
  );
}

function validate(prefs, payload) {
  const area = payload.area;
  if (prefs.length === 0) {
    const validatedPayload = Object.keys(payload).reduce((acc, item) => {
      if (payload[item] !== undefined) {
        acc[item] = payload[item];
      }
      return acc;
    }, {});

    prefs.push({ ...validatedPayload, area });
    return prefs;
  }
  const combined = prefs.map(item => {
    if (item.area === area) {
      return getCombinedPrefs(item, { ...payload, area });
    }
    return item;
  });

  const areas = combined.map(item => item.area);
  if (areas.indexOf(area) === -1) {
    combined.push({ ...payload, area });
  }
  return combined;
}

export default function boligAgents(state = initialState, action) {
  switch (action.type) {
    case VERIFY_FAIL:
    case LOAD_FAIL:
      return {
        ...state,
        current: null,
        loading: false
      };
    case CROSS_DOMAIN_NAVIGATION:
      facebookSavePrefs(state.sessionPrefs);
      return state;
    case DELETE_SUCCESS:
      return {
        ...state,
        current: action.payload
      };
    case DELETE_FAIL:
      return {
        ...state,
        current: null
      };
    case DELETE_PREF_SUCCESS:
      return {
        sessionPrefs: action.payload.prefs,
        current: action.payload
      };
    case CREATE_SUCCESS:
    case USER_CREATE_SUCCES:
      visitor(HAS_BOLIGAGENT, 1);
      return {
        ...state,
        current: action.payload.boligagent
      };
    case VERIFY_SUCCESS:
    case LOAD_SUCCESS:
    case UPDATE_SUCCESS:
    case ACTIVATE_SUCCESS:
    case SET_AUTO_ADJUST_SUCCESS:
      return {
        ...state,
        current: action.payload,
        loading: false
      };
    case ADJUST_SESSION:
      return {
        ...state,
        sessionPrefs: validate(state.sessionPrefs, action.payload)
      };
    case LOGOUT:
      return {
        current: null,
        sessionPrefs: []
      };
    case SESSION_FAIL:
      return {
        ...state,
        loading: false
      };
    case SESSION_SUCCESS:
    case LOGIN_SUCCESS:
    case USER_CONFIRMATION_SUCCESS:
      return {
        ...state,
        current: action.payload.boligagent,
        loading: false
      };
  }
  return state;
}

export function createBoligAgent(data, options = {}) {
  //const data = !prefs.length ? { prefs: [{ area: area.slug, ...sanitize(detail) }] } : { prefs };
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: client =>
      client.post(`${ENDPOINT}`, { data }).then(action => {
        if (action.status === 'OK' && !options.noTracking) {
          tracking.action('boligagent-signup');
        }
        return action;
      })
  };
}

export function loadBoligagent(token) {
  return {
    types: [LOAD, SESSION_SUCCESS, LOAD_FAIL],
    promise: client =>
      client.get(`${ENDPOINT}/${token}`).then(action => {
        return action;
      })
  };
}

export function verifyBoligagent(token) {
  return {
    types: [VERIFY, SESSION_SUCCESS, VERIFY_FAIL],
    promise: client =>
      client.post(`${ENDPOINT}/${token}/verify`).then(action => {
        //TODO: add tracking
        return action;
      })
  };
}

export function deleteBoligagent() {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: client => client.delete(`${ENDPOINT}`)
  };
}

export function deletePref(obj) {
  return {
    types: [DELETE_PREF, DELETE_PREF_SUCCESS, DELETE_PREF_FAIL],
    promise: client =>
      client.delete(`${ENDPOINT}/pref?id=${obj.id}&area=${obj.area}`)
  };
}

export function updateBoligagent(data) {
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: client => client.put(`${ENDPOINT}`, { data })
  };
}

export function activatePref(data) {
  return {
    types: [ACTIVATE, ACTIVATE_SUCCESS, ACTIVATE_FAIL],
    promise: client => client.put(`${ENDPOINT}/pref`, { data })
  };
}

const KEYS = ['rent', 'rooms', 'size'];

function sanitize(obj) {
  if (!obj) {
    return {};
  }
  return KEYS.reduce((acc, item) => {
    if (obj[item]) {
      acc[item] = obj[item];
    }
    return acc;
  }, {});
}

function selectValue(identifier, val1, val2) {
  switch (identifier) {
    case 'rent':
      return val1 > val2 ? val1 : val2;
    case 'rooms':
    case 'size':
      return val1 < val2 ? val1 : val2;
  }
}

function merge(arr, obj) {
  const output = {};
  arr.forEach(item => {
    KEYS.forEach(key => {
      if (item[key] && obj[key]) {
        output[key] = selectValue(key, item[key], obj[key]);
      } else if (item[key] || (obj[key] && obj[key])) {
        output[key] = item[key] || obj[key];
      }
    });
  });
  return output;
}

export function adjustBoligagent(data) {
  const { user, area, detail, current } = data;

  const existingAreas =
    (current &&
      current.prefs &&
      current.prefs.filter(pref => pref.area === area)) ||
    [];
  const newPrefs = sanitize(detail);

  if (user && current.autoAdjust) {
    const rent = snapRent(newPrefs.rent);
    const rooms = snapRoom(newPrefs.rooms);

    if (
      existingAreas.length &&
      Object.keys(newPrefs).length &&
      !existingAreas.filter(pref => pref.status === false).length
    ) {
      return {
        types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
        promise: client =>
          client.put(`${ENDPOINT}`, {
            data: {
              id: current.id,
              area,
              prefs: { ...merge(existingAreas, { rent, rooms }) }
            }
          })
      };
    }
    if (!existingAreas.length) {
      return {
        types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
        promise: client =>
          client.post(`${ENDPOINT}/`, {
            data: { prefs: [{ area, rent, rooms }] }
          })
      };
    }
  }
  if (!user) {
    return {
      type: ADJUST_SESSION,
      payload: { area, ...newPrefs }
    };
  }

  return {
    type: NOOP
  };
}

export function setAutoAdjust(data) {
  return {
    types: [SET_AUTO_ADJUST, SET_AUTO_ADJUST_SUCCESS, SET_AUTO_ADJUST_FAIL],
    promise: client => client.post(`${ENDPOINT}/settings`, { data })
  };
}
